import React from "react"
import { useSelector, useDispatch } from "react-redux"
import Select from "react-select"
import {
  Button,
  Col,
  FormFeedback,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"
import AttendanceAction from "store/attendance-resource/actions"

function ModalAdd({
  date,
  isOpen,
  toggle,
  validation,
  index,
  initloading,
  setInitLoading,
  dataTemp,
  setDataTemp,
}) {
  const dispatch = useDispatch()
  const store = useSelector(state => state)
  const [tempCategory, setTempCategory] = React.useState("作業")
  const [tempData, setTempData] = React.useState({})

  React.useEffect(() => {
    if (validation.values.workingHours[index]) {
      setTempData(validation.values.workingHours[index])
    } else {
      setTempData(dataTemp)
    }
  }, [isOpen])

  React.useEffect(() => {
    dispatch(AttendanceAction.getAllOrderList())
    dispatch(AttendanceAction.getOtherWork())
  }, [])

  const saveData = () => {
    const current = validation.values.workingHours
    current[index] = { ...tempData, category: tempCategory }
    validation.setFieldValue("workingHours", current)
    setInitLoading(true)
    setTimeout(() => {
      setInitLoading(false)
    }, 200)
    toggle()
  }

  const cancelAddWorking = () => {
    setDataTemp({})
    setTempData({})
    toggle()
  }

  return (
    <Modal isOpen={isOpen} size="lg" toggle={toggle}>
      <ModalHeader toggle={toggle}>{date}</ModalHeader>
      <ModalBody>
        <Row>
          <Col lg="2">
            <Label>従業員名</Label>
          </Col>
          <Col>
            <Input disabled value={validation.values.staffName} />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col lg="2">
            <Label>作業区分</Label>
          </Col>
          <Col lg="3">
            <Input
              type="radio"
              id="orderNumber"
              checked={tempCategory == "作業"}
              onClick={() => {
                setTempCategory("作業")
                setTempData({
                  ...tempData,
                  category: "作業",
                  otherWorkName: "",
                  otherWorkId: "",
                })
              }}
            />
            <Label className="ms-2" htmlFor="orderNumber">
              受注番号
            </Label>

            <Select
              isLoading={store.attendance.order.loading}
              options={store.attendance.order.data.map(i => ({
                label: i.orderNumber,
                value: i.id,
                customerName: i.customerName,
                productName: i.productName,
              }))}
              value={{
                label: tempData?.orderNumber,
                value: tempData?.orderId,
              }}
              defaultValue={{
                label: tempData?.orderNumber,
                value: tempData?.orderId,
              }}
              isDisabled={tempCategory !== "作業"}
              isClearable
              onChange={e => {
                if (e) {
                  setTempData({
                    ...tempData,
                    orderNumber: e.label,
                    orderId: e.value,
                    customerName: e.customerName,
                    productName: e.productName,
                  })
                } else {
                  setTempData({
                    ...tempData,
                    orderNumber: "",
                    orderId: "",
                    customerName: "",
                  })
                }
              }}
            />
          </Col>
          <Col lg="3">
            <Input
              type="radio"
              id="other"
              checked={tempCategory == "その他"}
              onClick={() => {
                setTempCategory("その他")
                setTempData({
                  ...tempData,
                  category: "その他",
                  orderNumber: "",
                  orderId: "",
                  customerName: "",
                  productName: "",
                })
              }}
            />
            <Label className="ms-2" htmlFor="other">
              その他
            </Label>

            <Select
              isLoading={store.attendance.otherWork.loading}
              options={store.attendance.otherWork.data.map(i => ({
                value: i.id,
                label: i.name,
                customerName: i.customerName,
              }))}
              isDisabled={tempCategory !== "その他"}
              value={{
                label: tempData?.otherWorkName,
                value: tempData?.otherWorkId,
              }}
              defaultValue={{
                label: tempData?.otherWorkName,
                value: tempData?.otherWorkId,
              }}
              isClearable
              onChange={e => {
                if (e) {
                  setTempData({
                    ...tempData,
                    otherWorkName: e.label,
                    otherWorkId: e.value,
                  })
                } else {
                  setTempData({
                    ...tempData,
                    otherWorkName: "",
                    otherWorkId: "",
                  })
                }
              }}
            />
          </Col>
          <Col lg="3">
            <Input
              type="radio"
              id="inspection"
              checked={tempCategory == "検品"}
              onClick={() => {
                setTempCategory("検品")
                setTempData({
                  ...tempData,
                  category: "検品",
                  orderNumber: "",
                  orderId: "",
                  customerName: "",
                  otherWorkName: "",
                  otherWorkId: "",
                  productName: "",
                })
              }}
            />
            <Label className="ms-2" htmlFor="inspection">
              検品
            </Label>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col lg="2">
            <Label>顧客名</Label>
          </Col>
          <Col>
            <Input value={tempData?.customerName || ""} disabled />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col lg="2">
            <Label>作業時間</Label>
          </Col>
          <Col lg="3">
            <InputGroup>
              <Input
                type="number"
                name={`workingHours[${index}].hour`}
                className="form-control"
                value={tempData?.hour || ""}
                onChange={e =>
                  setTempData({ ...tempData, hour: e.target.value })
                }
              />
              <InputGroupText>時間</InputGroupText>
            </InputGroup>
          </Col>
          <Col lg="3">
            <InputGroup>
              <Input
                type="number"
                name={`workingHours[${index}].minute`}
                className="form-control"
                value={tempData?.minute || ""}
                onChange={e =>
                  setTempData({ ...tempData, minute: e.target.value })
                }
              />
              <InputGroupText>分</InputGroupText>
            </InputGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button onClick={cancelAddWorking} className="button">
          キャンセル
        </Button>
        <Button onClick={saveData} className="button">
          保存
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalAdd
